// src/seoConfig.ts

interface SEOData {
  title: string;
  description: string;
  keywords: string;
  url: string;
  image: string;
}

const BASE_URL = "https://manikarndigital.com";
const IMAGE_PATH = `${BASE_URL}/images`;

export const seoConfig: Record<string, SEOData> = {
  home: {
    title: "Manikarn Digital - Web Design, Development & Digital Marketing",
    description: "Professional web design, development, SEO, and digital marketing services to help your business grow online.",
    keywords: "Manikarn Digital, web design, development, SEO, digital marketing, India",
    url: `${BASE_URL}/`,
    image: `${IMAGE_PATH}/home-og.jpg`,
  },
  about: {
    title: "About Us - Manikarn Digital",
    description: "Learn about Manikarn Digital — who we are, our mission, vision, and the services we offer.",
    keywords: "Manikarn Digital, about, our story, vision, mission, services",
    url: `${BASE_URL}/about`,
    image: `${IMAGE_PATH}/about-og.jpg`,
  },
  testimonials: {
    title: "Testimonials - Manikarn Digital",
    description: "See what our clients have to say about working with Manikarn Digital.",
    keywords: "Manikarn Digital reviews, client testimonials, feedback",
    url: `${BASE_URL}/testimonials`,
    image: `${IMAGE_PATH}/testimonials-og.jpg`,
  },
  ourTeam: {
    title: "Our Team - Manikarn Digital",
    description: "Meet the talented team behind Manikarn Digital’s success.",
    keywords: "Manikarn Digital team, staff, professionals, experts",
    url: `${BASE_URL}/our-team`,
    image: `${IMAGE_PATH}/team-og.jpg`,
  },
  services: {
    title: "Our Services - Manikarn Digital",
    description: "Explore our range of services including web design, SEO, and digital marketing.",
    keywords: "Manikarn Digital services, web design, SEO, digital marketing, branding",
    url: `${BASE_URL}/services`,
    image: `${IMAGE_PATH}/services-og.jpg`,
  },
  webDesignDevelopment: {
    title: "Web Design & Development - Manikarn Digital",
    description: "Custom, responsive, and user-friendly website design and development services.",
    keywords: "web design, website development, responsive design, UI/UX",
    url: `${BASE_URL}/web-design-development`,
    image: `${IMAGE_PATH}/web-design-og.jpg`,
  },
  digitalMarketing: {
    title: "Digital Marketing - Manikarn Digital",
    description: "SEO, social media, and digital advertising services to grow your online presence.",
    keywords: "digital marketing, SEO, PPC, social media marketing",
    url: `${BASE_URL}/digital-marketing`,
    image: `${IMAGE_PATH}/digital-marketing-og.jpg`,
  },
  graphicDesigning: {
    title: "Graphic Designing - Manikarn Digital",
    description: "Creative and professional graphic design services for branding and marketing.",
    keywords: "graphic design, branding, logo design, creatives",
    url: `${BASE_URL}/graphic-designing`,
    image: `${IMAGE_PATH}/graphic-design-og.jpg`,
  },
  hostingSupport: {
    title: "Hosting & Support - Manikarn Digital",
    description: "Reliable web hosting and technical support services for your business.",
    keywords: "web hosting, website support, maintenance",
    url: `${BASE_URL}/hosting-support`,
    image: `${IMAGE_PATH}/hosting-support-og.jpg`,
  },
  websiteCare: {
    title: "Website Care - Manikarn Digital",
    description: "Ongoing website maintenance and updates to keep your site running smoothly.",
    keywords: "website care, maintenance, updates, support",
    url: `${BASE_URL}/website-care`,
    image: `${IMAGE_PATH}/website-care-og.jpg`,
  },
  portfolio: {
    title: "Portfolio - Manikarn Digital",
    description: "Check out our past projects and successful case studies.",
    keywords: "Manikarn Digital portfolio, projects, case studies",
    url: `${BASE_URL}/portfolio`,
    image: `${IMAGE_PATH}/portfolio-og.jpg`,
  },
  blog: {
    title: "Blog - Manikarn Digital",
    description: "Latest news, tips, and trends in web design and digital marketing.",
    keywords: "blog, SEO tips, web design trends, marketing ideas",
    url: `${BASE_URL}/blog`,
    image: `${IMAGE_PATH}/blog-og.jpg`,
  },
  contact: {
    title: "Contact Us - Manikarn Digital",
    description: "Get in touch with our team for any inquiries or project discussions.",
    keywords: "contact Manikarn Digital, support, inquiry, get in touch",
    url: `${BASE_URL}/contact`,
    image: `${IMAGE_PATH}/contact-og.jpg`,
  },
};
